module.exports = __webpack_public_path__ + "static/media/layout_2.ef65ea45.png";